module.exports = __webpack_public_path__ + "img/piece-locked-2.5269269a.svg";